"use client";

import React from "react";
import { Users } from "lucide-react";
import { AttendeeList } from "./attendee/AttendeeList";
import { StandardModal } from "./shared/StandardModal";
import { type AttendeeData } from "../../lib/attendee-utils";

interface Attendee {
  email: string;
  name?: string;
  responseStatus?: string;
  isOrganizer?: boolean;
}

interface AttendeeDetailsModalProps {
  attendees: AttendeeData[];
  organizer?: AttendeeData;
  isOpen: boolean;
  onClose: () => void;
  eventTitle?: string;
  onComposeEmail?: (recipients: string[], subject?: string) => void;
}

export function AttendeeDetailsModal({
  attendees,
  organizer,
  isOpen,
  onClose,
  eventTitle,
  onComposeEmail,
}: AttendeeDetailsModalProps) {
  return (
    <StandardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Attendee Details"
      subtitle={eventTitle}
      icon={Users}
      maxWidth="2xl"
    >
      <AttendeeList
        attendees={attendees}
        organizer={organizer}
        onComposeEmail={onComposeEmail}
        maxVisible={50} // Show all in modal
        showSummary={true}
        variant="detailed"
      />
    </StandardModal>
  );
} 